import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class DasUBootAvalancheBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => flowStateController.finish()});

        tl.add(gsap.to(this, {duration:0.001}));

/*
        const delay = DasUBootReelsView.stepDuration;
        tl.add(SymbolUtils.getSymbolStateAnimations(DasUBoot.reelView.getAllVisibleSymbols(), DasUBootSymbolStates.NORMAL));
        tl.add(() => DasUBoot.textView.update(`DasUBootNormalBetPresentation`));
        tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.REELS_SPINNING));
        tl.add(DasUBoot.reelView.reelModels[0].start(false), delay * 1.5);
        tl.add(DasUBoot.reelView.reelModels[1].start(false), delay * 1);
        tl.add(DasUBoot.reelView.reelModels[2].start(false), delay * 0.5);
        tl.add(DasUBoot.reelView.reelModels[3].start(false), delay * 0.5);
        tl.add(DasUBoot.reelView.reelModels[4].start(false), delay * 1);
        tl.add(DasUBoot.reelView.reelModels[5].start(false), delay * 1.5);*/
    }
}